import { Controller } from '@hotwired/stimulus'

// Adds a locale section to the draft editor without a page round-trip
// (unsaved edits stay put). The template's field names contain __CODE__,
// replaced with the typed locale code. Entirely blank sections are dropped
// server-side on save.
export default class extends Controller {
  static targets = ['list', 'template', 'input']

  add(event) {
    event.preventDefault()
    const code = this.inputTarget.value.trim().toLowerCase()
    if (!/^[a-z]{2,3}$/.test(code)) {
      this.inputTarget.focus()
      return
    }
    if (this.element.querySelector(`[data-locale-section="${code}"]`)) {
      this.inputTarget.value = ''
      return
    }

    const html = this.templateTarget.innerHTML.replaceAll('__CODE__', code)
    this.listTarget.insertAdjacentHTML('beforeend', html)
    this.inputTarget.value = ''
    this.listTarget.lastElementChild.querySelector('input[type=text]')?.focus()
  }
}
